import React, { useEffect, useState } from 'react';
import './Blog.css';

const Typewriter = ({ text }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let timeout;
    if (isTyping) {
      timeout = setTimeout(() => {
        if (index < text.length) {
          setDisplayedText((prev) => prev + text[index]);
          setIndex(index + 1);
        } else {
          setIsTyping(false);
        }
      }, 110);
    } else {
      timeout = setTimeout(() => {
        setDisplayedText('');  
        setIndex(0);           
        setIsTyping(true);      
      }, 10000);
    }

    return () => clearTimeout(timeout);
  }, [index, isTyping, text]);

  return (
    <div>
      <span className="typewriter-text">{displayedText}</span>
      <span className="typewriter-cursor"></span>
    </div>
  );
};

export default Typewriter;
